import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { Tabs } from '@garnish/layout';

export const ScanToPayTab = (props: ComponentProps<typeof Tabs.Panel>) => {
  const { style, children, ...rest } = props;

  return (
    <Tabs.Panel style={[props.isActive ? styles.tab : undefined, style]} {...rest}>
      {children}
    </Tabs.Panel>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  tab: {
    flex: 1,
  },
});
